import React from 'react'
import styled, {CSSProperties} from 'styled-components'
import {useTranslation} from 'i18n'
import {Button, Modal, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {getCurrencyValue} from 'utils'
import {useWindowMode} from 'windows'
import {
  TransactionDetailContentItemSingleCreator,
  TransactionDetailPackageItemSingleCreator,
} from 'pages/transaction'
import {GiftShopTemplateDetailContentMultipleListModalProps} from './GiftShopTemplateDetailContentMultipleListModalProps'

const StyledConfirmationModal = styled.div<CSSProperties>`
  display: flex;
  flex-direction: column;
  width: ${({width = convertUnit(275)}) => width};
  padding: ${convertUnit(25)};
  background-color: ${({theme}) => theme.white_1};
  border-radius: ${convertUnit(8)};
  position: relative;
  transition: all 5s ease-in-out;
  z-index: 5;
`

const StyledItemEnd = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-self: start;
  gap: ${convertUnit(4)};
  margin-bottom: ${convertUnit(8)};
`

const StyledStrikeThroughParagraph = styled(Paragraph)`
  text-decoration: line-through;
`

const StyledButtonClose = styled(Button)`
  margin-top: ${convertUnit(32)};
`

export default function GiftShopTemplateDetailContentMultipleListModal({
  data,
  visible,
  toggleModal,
  showDiscount = false,
  onClickItem,
}: GiftShopTemplateDetailContentMultipleListModalProps) {
  const mode = useWindowMode()
  const {translate} = useTranslation()
  const {
    creator_name,
    content = [],
    package: packageData = [],
    price_detail,
  } = data

  return (
    <Modal visible={visible}>
      <StyledConfirmationModal>
        <Paragraph
          fontWeight="bold"
          color="black_1"
          fontSize="l"
          lineHeight={24}>
          {mode === 'mobile' && creator_name && creator_name.length > 15
            ? `${creator_name.slice(0, 15)}...`
            : creator_name}
        </Paragraph>
        <StyledItemEnd>
          {!showDiscount || price_detail.discount.nominal === 0 ? (
            <Paragraph fontSize="s" fontWeight="bold" color="info_5">
              {getCurrencyValue(price_detail.final.nominal)}
            </Paragraph>
          ) : (
            <>
              <Paragraph fontSize="s" fontWeight="bold" color="info_5">
                {getCurrencyValue(price_detail.final.nominal)}
              </Paragraph>
              <StyledStrikeThroughParagraph fontSize="s" color="gray_3">
                {getCurrencyValue(price_detail.final_without_discount.nominal)}
              </StyledStrikeThroughParagraph>
            </>
          )}
        </StyledItemEnd>
        <div
          style={{
            maxHeight: convertUnit(400),
            overflowY: 'auto',
          }}>
          {packageData.map((entry) => (
            <TransactionDetailPackageItemSingleCreator
              key={entry.id}
              content={entry}
              showDiscount={showDiscount}
            />
          ))}
          {content.map((entry) => (
            <TransactionDetailContentItemSingleCreator
              key={entry.content_id}
              content={entry}
              onClickItem={() => onClickItem(entry)}
              showDiscount={showDiscount}
            />
          ))}
        </div>
        <StyledButtonClose
          label={translate('global:cancel')}
          backgroundHoverColor="white_3"
          backgroundColor="white_2"
          color="primary_5"
          onClick={() => {
            toggleModal()
          }}
        />
      </StyledConfirmationModal>
    </Modal>
  )
}
